module.exports = __webpack_public_path__ + "static/media/payment_success.633e9830.svg";